import React, { useState, useEffect, useContext } from 'react';
import CommentTemplateService from "../../controller/CommentTemplateController/CommentTemplateController";
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { Link } from "react-router-dom";
import CreateCommentTemplate from './CreateCommentTemplate';
import HelpSite from "../../../Common/HelpLink";
function CommentTemplateServicePage() {
    const navigate = useNavigate();
    const [CommentTemplatesDataList, setCommentTemplatesData] = useState([]);
    const { theme } = useContext(ThemeContext);
    const accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";
    const [modalInstance, setModalInstance] = useState(null);
    const [currentComment, setCurrentComment] = useState(null);

    const fetchCommentTemplates = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const CommentTemplatesData = await CommentTemplateService.GetAllCommentTemplates(redirectCallback);
            setCommentTemplatesData(CommentTemplatesData);
        } catch (error) {
            console.error('Error fetching comment templates:', error);
        }
    };

    useEffect(() => {
        fetchCommentTemplates();
    }, []);

    useEffect(() => {
        const modalElement = document.getElementById('commentTemplateModal');
        if (modalElement) {
            setModalInstance(new window.bootstrap.Modal(modalElement));
        }
    }, []);

    const handleCommentTemplateClick = () => {
        setCurrentComment(null);
        if (modalInstance) {
            modalInstance.show();
        }
    };

    const handleCloseModal = () => {
        if (modalInstance) {
            modalInstance.hide();
        }
    };

    const handleEditClick = (comment) => {
        setCurrentComment(comment);
        if (modalInstance) {
            modalInstance.show();
        }
    };

    const handleDeleteClick = async (ID) => {
        const confirmed = window.confirm("Are you sure you want to delete this comment template?");
        if (confirmed) {
            try {
                await CommentTemplateService.DeleteComment(ID);
                fetchCommentTemplates();
            } catch (error) {
                console.error('Error deleting comment template:', error);
            }
        }
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3">
                <div className="col-sm-3">
                    <button className='btn btn-primary btn-sm' onClick={handleCommentTemplateClick}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </button>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>
                    <HelpSite FormName="Update Templates" Module="26" />
                </div>
            </div>
            <table className="table m-0 table-hover">
                <thead>
                    <tr>

                        <th>Title</th>
                        <th>Service Code</th>
                        <th style={{ "textAlign": "right" }}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {CommentTemplatesDataList.map((comment, index) => (
                        <tr key={comment.ID} onClick={() => handleEditClick(comment)}>

                            <td>{comment.vc_Title}</td>
                            <td>{comment.vc_ServiceCode}</td>
                            <td style={{ "textAlign": "right" }}>
                                
                                <button className="text-danger" style={{ "background": "none", "border": "none" }} onClick={() => handleDeleteClick(comment.ID)}>
                                    <i className="icofont-ui-delete" aria-hidden="true"></i>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <CreateCommentTemplate comment={currentComment} onClose={handleCloseModal} onSuccess={fetchCommentTemplates} />
        </div>
    );
}

export default CommentTemplateServicePage;
